@if (card) {
  <section class="tabs">
    @for (item of card.data; track item) {
      <div class="tab" (click)="setSelected(item)">
        <img [src]="item.tabbar_icon" alt="" />
        <div class="indicator" [ngClass]="{ active: activeTab(item.id) }"></div>
      </div>
    }
  </section>
}

@if (reinit) {
  <div style="min-height: 365px; min-width: 365px; display: flex; align-items: center; justify-content: center">
    <app-loading-indicator></app-loading-indicator>
  </div>
}

@if (card_data && !reinit) {
  <app-carousel [config]="splideConfig">
    @for (item of selected.items; track item) {
      <app-slide (click)="openLink(item.link)">
        <article [style.backgroundImage]="backgroundImage(item.media_content)" [style.aspectRatio]="aspect_ratio">
          <footer class="media-description">
            <div class="account-info">
              @if (validImage(profileImage)) {
                <app-image [image_url]="profileImage" width="42px" height="42px" border_radius="50%" margin="0.5rem"></app-image>
              }
              <span> {{ selected.title }} </span>
            </div>
            <div class="post-content" [innerHTML]="parseDesc(item.description, selected.feed_type)"></div>
          </footer>
        </article>
      </app-slide>
    }
  </app-carousel>
}
